// extracted by mini-css-extract-plugin
module.exports = {"ordinalInput":"_30sIrXpJ1nM6dRZLzwyAzy"};